import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';
import _ from 'lodash';
import moment from 'moment';

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: ['Reports']
});

export const reportsApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    getSavedExports: build.query({
      async queryFn() {
        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.JOURNALEXPORT,
            {
              orderBy: 'Created',
              orderDirection: 'desc'
            }
          );
          return { data: res?.Objects || [] };
        } catch (error) {
          return { error };
        }
      },
      providesTags: [{ type: 'Reports', id: 'SAVED_EXPORTS' }]
    }),

    getDataExportMonths: build.query({
      async queryFn() {
        try {
          const monthlyRes = await api.Signing2.monthly();

          const dataExportMonths = [];
          _.map(monthlyRes, (value, key) => {
            const dt = moment(key + '-01');
            dataExportMonths.push({
              displayKey: key,
              begin: dt.format('YYYY-MM-DD'),
              title: dt.format('MMMM-YYYY'),
              end: dt.endOf('month').format('YYYY-MM-DD'),
              signingCount: value
            });
          });

          return { data: dataExportMonths };
        } catch (error) {
          return { error };
        }
      },
      providesTags: [{ type: 'Reports', id: 'MONTHS' }]
    })
  })
});

export const { useGetSavedExportsQuery, useGetDataExportMonthsQuery } =
  reportsApi;
